import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/components/containers/Pages/Services/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
